<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(filterdata)" class="mb-5">
                <v-card>
                  <v-expansion-panels v-model="panel" multiple focusable>
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        $t("language.filter")
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card-text>
                          <v-container grid-list-xl>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="filter.roleid"
                                  :items="RoleList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.role')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            dense
                            color="general"
                            class="mr-2"
                            light
                            type="submit"
                            >{{ $t("language.filter") }}</v-btn
                          >
                          <v-btn
                            dense
                            class="mr-2"
                            light
                            @click="resetFilter"
                            >{{ $t("language.clear") }}</v-btn
                          >
                        </v-card-actions>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>
              </v-form>
            </ValidationObserver>
            <ValidationObserver
              ref="form"
              v-slot="{ passes }"
              v-if="pages.length > 0"
            >
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 md12>
                          <v-treeview
                            selectable
                            :items="pages"
                            v-model="vModel.selectedpages"
                            item-children="children"
                            item-key="id"
                            item-text="pagetitle"
                          ></v-treeview>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="blue darken-1" text type="submit">{{
                      $t("language.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import EngNepDatePicker from "../../../components/shared/EngNepDatePicker";
import Base from "../../../shared/Base.vue";
import commonservice from "../../../shared/common.service";
export default {
  name: "userpermissionview",
  extends: Base,
  components: {
    EngNepDatePicker,
  },
  data() {
    return {
      filter: {},
      panel: [1],
      RoleList: [],
      pages: [],
    };
  },
  created() {
    this.panel = [...Array(1).keys()].map((k, i) => i);
    this.url = "client/setup/userpermissions";
    this.resetFilter();
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/setup/userpermissions/init/list").then((response) => {
      next((p) => {
        p.RoleList = response.data.roles.map((item) => {
          return {
            id: item.id,
            name: p.$t("language." + item.name.toLowerCase()),
          };
        });
      });
    });
  },
  methods: {
    resetFilter() {
      this.filter = {
        roleid: null,
      };
    },
    filterdata() {
      this.pages = [];
      this.vModel.selectedpages = [];
      this.vModel.roleid = this.filter.roleid;
      axios
        .get(
          "client/setup/userpermissions?" +
            this.convertToQueryString(this.filter)
        )
        .then((response) => {
          this.vModel.selectedpages = response.data.selectedpages;
          this.pages = this.getpages(response.data.pages);
          this.isEdit = true;
          if (this.pages.length == 0) {
            this.$store.dispatch(
              "showErrorMessage",
              this.$t("language.nodatafound")
            );
          }
        });
    },
    getpages(list) {
      return list.map((item) => {
        return {
          id: item.id,
          pagetitle: this.$t("language." + item.pagekey),
          children: item.children ? this.getpages(item.children) : [],
        };
      });
    },
  },
};
</script>
